<template>
  <section>
    <p>Colas</p>
    <activity-overview :type="type" :moduleType="moduleType" />
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import ActivityOverview from "@/components/Agents/ActivityOverview/Queue";
export default {
  components: {
    ActivityOverview,
  },
  data() {
    return {
      type: "queue",
      moduleType: "agentsQueue"
    };
  },
};
</script>

<style>
</style>